import React from "react";
import PeopleGroupIcon from "@atlaskit/icon/glyph/people-group";
import PeopleIcon from "@atlaskit/icon/glyph/people";
import {
  HeaderLabel,
  OptionIcon,
  OptionImage,
  OptionLabel,
  OptionWrapper,
} from "./styled";
import { PickerOptionTypes } from "./option-types";
import { useTranslation } from "react-i18next";

export const StyledHeader = ({ type }) => {
  const { t } = useTranslation();
  return (
    <HeaderLabel>
      {type === PickerOptionTypes.USER && t("people")}
      {type === PickerOptionTypes.GROUP && t("confluence-group")}
      {type === PickerOptionTypes.COLLECTION && t("cosmos-collection")}
    </HeaderLabel>
  );
};

export const StyledLabel = ({ type, data }) => {
  return (
    <OptionWrapper>
      {type === PickerOptionTypes.USER && (
        <>
          <OptionImage
            src={`${window.AP._hostOrigin}${data?.profilePicture?.path}`}
            alt="user-image"
          />
          <OptionLabel>{data?.displayName}</OptionLabel>
        </>
      )}
      {type === PickerOptionTypes.GROUP && (
        <>
          <OptionIcon>
            <PeopleGroupIcon size="small" primaryColor="#97A0AF" />
          </OptionIcon>
          <OptionLabel>{data?.name}</OptionLabel>
        </>
      )}
      {type === PickerOptionTypes.COLLECTION && (
        <>
          <OptionIcon>
            <PeopleIcon size="small" primaryColor="#97A0AF" />
          </OptionIcon>
          <OptionLabel>{data?.name}</OptionLabel>
        </>
      )}
    </OptionWrapper>
  );
};
